// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vq-8";
export var editMode = "_vq-3";
export var headerRow = "_vq-a";
export var headerTitle = "_vq-b";
export var product = "_vq-1";
export var productDetails = "_vq-5";
export var productDivider = "_vq-7";
export var productImage = "_vq-2";
export var productInfo = "_vq-4";
export var productTitle = "_vq-6";
export var strikethrough = "_vq-9";
export var upsellProductsCard = "_vq-0";